import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import ServiceListItem from './ServiceListItem';
import dataAids from '../../common/constants/dataAids';

const styles = {
  categoryName: {
    marginBottom: 'large'
  },
  categorySeparator: {
    marginBottom: 'xlarge'
  },
  seeAll: {
    marginBottom: 'xlarge',
    cursor: 'pointer'
  }
};

export default class Category extends Component {
  constructor(props) {
    super(props);

    this.state = {
      areAllCategoryServicesShown: false
    };

    this.onSeeAllClick = this.onSeeAllClick.bind(this);
  }

  onSeeAllClick() {
    this.setState({ areAllCategoryServicesShown: true });
  }

  isSeeAllLinkShown() {
    const { areAllCategoryServicesShown } = this.state;

    const {
      category: { services },
      maxServicesShown
    } = this.props;

    return !areAllCategoryServicesShown && services.length > maxServicesShown;
  }

  getShownServices(isSeeAllLinkShown) {
    const { maxServicesShown } = this.props;
    let {
      category: { services }
    } = this.props;

    if (isSeeAllLinkShown) {
      services = services.slice(0, maxServicesShown);
    }

    return services;
  }

  render() {
    const {
      category,
      hasSeparator,
      maxServiceDescriptionEllipseCharacters,
      onServiceClick,
      staticContent,
      callToActionText,
      imageCropMethod,
      widgetCategory,
      navigate,
      renderMode
    } = this.props;
    const {
      Element: { Block, Heading, MoreLink, HR }
    } = UX2;

    const isSeeAllLinkShown = this.isSeeAllLinkShown();
    const shownServices = this.getShownServices(isSeeAllLinkShown);

    return shownServices.length ? (
      <Block>
        { hasSeparator && (
          <HR data-aid={ dataAids.CATEGORY_SEPARATOR } style={ styles.categorySeparator } />
        ) }
        { category.name && (
          <Heading.Middle data-aid={ dataAids.CATEGORY_NAME } tag='h3' style={ styles.categoryName }>
            { category.name }
          </Heading.Middle>
        ) }
        { shownServices.map(service => (
          <ServiceListItem
            key={ service.id }
            service={ service }
            staticContent={ staticContent }
            callToActionText={ callToActionText }
            maxServiceDescriptionEllipseCharacters={ maxServiceDescriptionEllipseCharacters }
            onServiceClick={ onServiceClick }
            imageCropMethod={ imageCropMethod }
            widgetCategory={ widgetCategory }
            navigate={ navigate }
            renderMode={ renderMode }
          />
        )) }
        { isSeeAllLinkShown && (
          <MoreLink.Expand
            data-aid={ dataAids.CATEGORY_SEE_ALL_LINK }
            onClick={ this.onSeeAllClick }
            style={ styles.seeAll }
            tag='span'
          >
            { staticContent.seeAll }
          </MoreLink.Expand>
        ) }
      </Block>
    ) : null;
  }
}

Category.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    services: PropTypes.array.isRequired
  }).isRequired,
  maxServicesShown: PropTypes.number.isRequired,
  maxServiceDescriptionEllipseCharacters: PropTypes.number.isRequired,
  hasSeparator: PropTypes.bool,
  onServiceClick: PropTypes.func,
  staticContent: PropTypes.object.isRequired,
  callToActionText: PropTypes.string.isRequired,
  imageCropMethod: PropTypes.string,
  widgetCategory: PropTypes.string,
  navigate: PropTypes.func.isRequired,
  renderMode: PropTypes.string.isRequired
};

Category.defaultProps = {
  hasSeparator: true
};
